import Seo from "@/components/Seo";
import { Btn } from "@/components/Btn";
import { MASCOT } from "@/lib/brand";

export default function NotFound() {
  return (
    <>
      <Seo path="/404" title="Page Not Found" noindex />
      <section className="bg-cream min-h-[70vh] flex items-center py-20">
        <div className="mx-auto max-w-xl px-4 md:px-8 text-center">
          <img src={MASCOT} alt="Skedaddle Junk Removal mascot" width="400" height="400" loading="lazy" decoding="async" className="w-40 mx-auto animate-float" />
          <h1 className="mt-6 font-heading font-bold text-6xl md:text-7xl text-coral">404</h1>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl">Well, this page skedaddled!</h2>
          <p className="mt-3 font-body text-lg text-charcoal/70">We could not find what you were looking for. Let us get you back on track.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Btn to="/" variant="primary" data-testid="notfound-home-btn">Back home</Btn>
            <Btn to="/contact" variant="secondary">Get My Free Quote</Btn>
          </div>
        </div>
      </section>
    </>
  );
}
